import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import BASE_URL from '../../config';

const initialState = {
  news: null,
  status: 'idle',
  error: null,
};

export const fetchNews = createAsyncThunk(
  'news/fetchNews',
  async ({ page, page_size }, { rejectWithValue }) => {
    try {
      const url = new URL(`${BASE_URL}/v1/news/`);
      url.searchParams.append('page', page);
      url.searchParams.append('page_size', page_size);

      const response = await fetch(url, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        return rejectWithValue(errorDetails);
      }

      return response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNews.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchNews.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.news = action.payload;
      })
      .addCase(fetchNews.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default newsSlice.reducer;
